import { useContext } from 'react';
import { Button, Grid, Typography, FormControlLabel, Checkbox, MenuItem, TextField as MdTextField, Switch } from '@mui/material';
import { Form, Field, useFormikContext } from 'formik';
import { TextField } from 'formik-mui';
import { customerContext, customerSchema } from '../CustomerContext';
import * as yup from 'yup';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Autocomplete } from 'components';
import { Locale } from 'helpers/Enums';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { IoWarningOutline as WarningIcon } from 'react-icons/io5';

interface ICustomerForm {
    formProps: any
}

let CustomerForm = (props: ICustomerForm) => {
    let { formatMessage } = useIntl();
    let router = useLocation();
    let service = useContext(customerContext);

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? 'Nuovo cliente' : `Modifica cliente`;

    type Customer = yup.InferType<typeof customerSchema>;
    let form = useFormikContext<Customer>();

    return (
        <Form>
            <Grid container>
                <Grid item xs>
                    <Typography variant="h1">{title}</Typography>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="email"
                        type="email"
                        label="Email"
                        disabled={isNew === false}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Field
                        component={TextField}
                        name="firstName"
                        label="Nome"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Field
                        component={TextField}
                        name="lastName"
                        label="Cognome"
                    />
                </Grid>
                <Grid item xs={12}>
                    <Autocomplete
                        inputLabel="Cliente"
                        value={{
                            value: props.formProps.values.customerId,
                            label: props.formProps.values.customerName
                        }}
                        doSearch={(value: string, etag: number) => service.searchCustomers(value, etag)}
                        onChange={(value: any) => {
                            props.formProps.setFieldValue('customerId', '' + value?.value || '0');
                            props.formProps.setFieldValue('customerName', value?.customerName || '');
                            props.formProps.setFieldValue('countryCode', value?.countryCode || '');
                            props.formProps.setFieldValue('countryName', value?.countryName || '');
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <MdTextField
                        select
                        label="Lingua"
                        size="small"
                        value={form.values.language}
                        onChange={(e: any) => props.formProps.setFieldValue('language', e.target.value)}
                    >
                        <MenuItem key={Locale.Italian} value={Locale.Italian}>Italiano</MenuItem>
                        <MenuItem key={Locale.English} value={Locale.English}>Inglese</MenuItem>
                    </MdTextField>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControlLabel
                        label="Amministratore"
                        name="isAdmin"
                        value={form.values.isAdmin}
                        checked={form.values.isAdmin}
                        onChange={(e: any) => form.setFieldValue('isAdmin', e.target.checked)}
                        control={<Field type="checkbox" name="isAdmin" component={Checkbox} color="secondary" />}
                    />
                </Grid>
                {isNew === true &&
                    <Grid item xs={12}>
                        <Typography color="primary">
                            <WarningIcon /> {formatMessage({ id: LocalizationIds.MailInviteWarning })}
                        </Typography>
                    </Grid>
                }
                {isNew === false &&
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            {isNew === false &&
                                <Grid item>
                                    <FormControlLabel
                                        label={"Cambia password"}
                                        name="resetPassword"
                                        value={form.values.resetPassword}
                                        checked={form.values.resetPassword}
                                        onChange={(e, value) => form.setFieldValue(`resetPassword`, value === true ? true : false)}
                                        control={<Switch name="resetPassword" />}
                                    />
                                </Grid>
                            }
                            {form.values.resetPassword === true &&
                                <>
                                    <Grid item xs>
                                        <Field
                                            component={TextField}
                                            name="newPassword"
                                            type="password"
                                            label="Nuova password"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs>
                                        <Field
                                            component={TextField}
                                            name="newPasswordConfirm"
                                            type="password"
                                            label="Conferma nuova password"
                                            fullWidth
                                        />
                                    </Grid>
                                </>
                            }
                        </Grid>
                    </Grid>
                }
            </Grid>
            <Grid container>
                <Grid item xs></Grid>
                <Grid item>
                    <Button
                        component={RouterLink}
                        variant="outlined"
                        color="secondary"
                        to={"/customers"}
                    >
                        Annulla
                    </Button>
                    <Button type="submit" variant="contained">
                        Salva
                    </Button>
                </Grid>
            </Grid>

        </Form >
    );
}

export default CustomerForm;